import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AWSDate: string;
  AWSDateTime: string;
  AWSEmail: string;
  AWSIPAddress: string;
  AWSJSON: string;
  AWSTime: string;
  AWSTimestamp: number;
  AWSURL: string;
};

export type AddCoApplicantInput = {
  dropOffPage?: InputMaybe<Scalars['String']>;
  email: Scalars['AWSEmail'];
  familyName: Scalars['String'];
  givenName: Scalars['String'];
  preQualificationIncomeSource?: InputMaybe<PreQualificationIncomeSourceInput>;
};

export type ApplicantsDocumentStatus = {
  __typename?: 'ApplicantsDocumentStatus';
  coApplicant?: Maybe<DocumentStatus>;
  primaryApplicant?: Maybe<DocumentStatus>;
};

export enum ApplicationStatus {
  ApplicationStarted = 'APPLICATION_STARTED',
  BankStatementSubmitted = 'BANK_STATEMENT_SUBMITTED',
  ClosedWon = 'CLOSED_WON',
  EmploymentDetailsSubmitted = 'EMPLOYMENT_DETAILS_SUBMITTED',
  FirmAgreement = 'FIRM_AGREEMENT',
  FulfillConditions = 'FULFILL_CONDITIONS',
  FullApprovalAccepted = 'FULL_APPROVAL_ACCEPTED',
  FullApprovalDenied = 'FULL_APPROVAL_DENIED',
  FullApprovalInfoRequired = 'FULL_APPROVAL_INFO_REQUIRED',
  FullApprovalStarted = 'FULL_APPROVAL_STARTED',
  FullApprovalSubmitted = 'FULL_APPROVAL_SUBMITTED',
  IncomeVerificationDocumentsSubmitted = 'INCOME_VERIFICATION_DOCUMENTS_SUBMITTED',
  Invited = 'INVITED',
  NoLongerLooking = 'NO_LONGER_LOOKING',
  OfferAccepted = 'OFFER_ACCEPTED',
  OfferDeclined = 'OFFER_DECLINED',
  OfferSubmitted = 'OFFER_SUBMITTED',
  PreparingOffer = 'PREPARING_OFFER',
  PreApprovalAccepted = 'PRE_APPROVAL_ACCEPTED',
  PreApprovalDenied = 'PRE_APPROVAL_DENIED',
  SentCommitmentLetter = 'SENT_COMMITMENT_LETTER',
  TouringHouses = 'TOURING_HOUSES'
}

export type ApplicationStatusInput = {
  applicationStatus?: InputMaybe<ApplicationStatus>;
  coApplicantBankStatementSubmittedViaOpenBanking?: InputMaybe<Scalars['Boolean']>;
  coApplicantDropOffPoint?: InputMaybe<Scalars['String']>;
  dropOffPage?: InputMaybe<Scalars['String']>;
  internalDealStage?: InputMaybe<InternalDealStage>;
  primaryApplicantBankStatementSubmittedViaOpenBanking?: InputMaybe<Scalars['Boolean']>;
};

export type ChildTaxBenefits = {
  __typename?: 'ChildTaxBenefits';
  monthlyAmount: Scalars['Float'];
};

export type ChildTaxBenefitsInput = {
  monthlyAmount: Scalars['Float'];
};

export type CoApplicantCreditReportConsentInput = {
  coApplicant: CreditReportConsentCoApplicantInput;
};

export type CoApplicantInfo = {
  __typename?: 'CoApplicantInfo';
  contactId?: Maybe<Scalars['String']>;
  creditReportConsentDateTime?: Maybe<Scalars['AWSDateTime']>;
  creditReportConsentGiven?: Maybe<Scalars['Boolean']>;
  currentAddress?: Maybe<CurrentAddress>;
  dateOfBirth?: Maybe<Scalars['AWSDate']>;
  email: Scalars['AWSEmail'];
  familyName: Scalars['String'];
  givenName: Scalars['String'];
  postalCode?: Maybe<Scalars['String']>;
};

export type CoApplicantPreApprovalInfo = {
  __typename?: 'CoApplicantPreApprovalInfo';
  annualIncome?: Maybe<Scalars['Float']>;
  creditScore?: Maybe<Scalars['Int']>;
  creditScoreKnown?: Maybe<Scalars['Boolean']>;
  email: Scalars['AWSEmail'];
  employmentDetails?: Maybe<EmploymentDetails>;
  familyName: Scalars['String'];
  givenName: Scalars['String'];
  inBankruptcy?: Maybe<Scalars['Boolean']>;
  monthlyDebtBreakdown?: Maybe<MonthlyDebtBreakdown>;
  monthlyDebtPayments?: Maybe<Scalars['Float']>;
  preQualificationIncomeSource?: Maybe<PreQualificationIncomeTypes>;
};

export type CoApplicantPreApprovalInfoInput = {
  annualIncome?: InputMaybe<Scalars['Float']>;
  creditScore?: InputMaybe<Scalars['Int']>;
  creditScoreKnown?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['AWSEmail']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  inBankruptcy?: InputMaybe<Scalars['Boolean']>;
  monthlyDebtBreakdown?: InputMaybe<MonthlyDebtBreakdownInput>;
  monthlyDebtPayments?: InputMaybe<Scalars['Float']>;
  preQualificationIncomeSource?: InputMaybe<PreQualificationIncomeSourceInput>;
};

export type CreditReportConsentCoApplicantInput = {
  email: Scalars['AWSEmail'];
};

export type CreditReportConsentInput = {
  coApplicant?: InputMaybe<CreditReportConsentCoApplicantInput>;
  primaryApplicant: CreditReportConsentPrimaryApplicantInput;
};

export type CreditReportConsentPrimaryApplicantInput = {
  consentGiven: Scalars['Boolean'];
  currentAddress: CurrentAddressInput;
  dateOfBirth?: InputMaybe<Scalars['AWSDate']>;
  postalCode?: InputMaybe<Scalars['String']>;
};

export type CurrentAddress = {
  __typename?: 'CurrentAddress';
  city: Scalars['String'];
  province: Province;
  streetAddress: Scalars['String'];
};

export type CurrentAddressInput = {
  city: Scalars['String'];
  province: Province;
  streetAddress: Scalars['String'];
};

export enum CurrentPage {
  IncomeVerification = 'INCOME_VERIFICATION',
  StatementUpload = 'STATEMENT_UPLOAD'
}

export enum CustomerFileCategory {
  ArticlesOfIncorporation = 'ARTICLES_OF_INCORPORATION',
  ChildTaxBenefit = 'CHILD_TAX_BENEFIT',
  CorporateFinancialStatementAndTaxReturns = 'CORPORATE_FINANCIAL_STATEMENT_AND_TAX_RETURNS',
  CreditCheck = 'CREDIT_CHECK',
  CreditScore = 'CREDIT_SCORE',
  DisabilityBenefit = 'DISABILITY_BENEFIT',
  DriverLicense = 'DRIVER_LICENSE',
  Electricity = 'ELECTRICITY',
  Financial = 'FINANCIAL',
  Identity = 'IDENTITY',
  InspectionReport = 'INSPECTION_REPORT',
  MoveInPictures = 'MOVE_IN_PICTURES',
  NaturalGasProvider = 'NATURAL_GAS_PROVIDER',
  NoticeOfAssessment = 'NOTICE_OF_ASSESSMENT',
  Other = 'OTHER',
  OtherIncomeSource = 'OTHER_INCOME_SOURCE',
  Passport = 'PASSPORT',
  PensionIncome = 'PENSION_INCOME',
  Personal = 'PERSONAL',
  PersonalTaxReturns = 'PERSONAL_TAX_RETURNS',
  RecentPayStubs = 'RECENT_PAY_STUBS',
  TenantInsuranceCertificate = 'TENANT_INSURANCE_CERTIFICATE',
  WaterAndWasteServices = 'WATER_AND_WASTE_SERVICES'
}

export type CustomerInfo = {
  __typename?: 'CustomerInfo';
  applicationStatus: ApplicationStatus;
  bankStatementUploaded?: Maybe<Scalars['Boolean']>;
  coApplicant?: Maybe<CoApplicantInfo>;
  coApplicantBankStatementSubmittedViaOpenBanking?: Maybe<Scalars['Boolean']>;
  coApplicantBankStatementUploaded?: Maybe<Scalars['Boolean']>;
  coApplicantDropOffPoint?: Maybe<Scalars['String']>;
  coApplicantEmail?: Maybe<Scalars['String']>;
  coApplicantIDUploaded?: Maybe<Scalars['Boolean']>;
  coApplicantIncomeVerificationUploaded?: Maybe<Scalars['Boolean']>;
  coApplicantWasRemoved?: Maybe<Scalars['Boolean']>;
  conditions?: Maybe<OfferConditions>;
  createdAt: Scalars['AWSDateTime'];
  creditReportConsentDateTime?: Maybe<Scalars['AWSDateTime']>;
  creditReportConsentGiven?: Maybe<Scalars['Boolean']>;
  currentAddress?: Maybe<CurrentAddress>;
  dateOfBirth?: Maybe<Scalars['AWSDate']>;
  documentStatus?: Maybe<ApplicantsDocumentStatus>;
  dropOffPage?: Maybe<Scalars['String']>;
  email: Scalars['AWSEmail'];
  emergencyContactAndOtherOccupants?: Maybe<EmergencyContactAndOtherOccupants>;
  familyName: Scalars['String'];
  favoriteListings?: Maybe<Array<Maybe<Listing>>>;
  fileUploads?: Maybe<Array<Maybe<File>>>;
  fullApprovalAcceptedInfo?: Maybe<FullApprovalAcceptedInfo>;
  fullApprovalDeniedReason?: Maybe<Scalars['String']>;
  givenName: Scalars['String'];
  hasGivenPhotoConsent?: Maybe<Scalars['Boolean']>;
  hasPreviousApplication?: Maybe<Scalars['Boolean']>;
  hasViewedPreQualificationIntro?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  inspection?: Maybe<Inspection>;
  isCoApplicant?: Maybe<Scalars['Boolean']>;
  isCurrentUserCoApplicant?: Maybe<Scalars['Boolean']>;
  offerInformation?: Maybe<OfferInformation>;
  phoneNumber: Scalars['String'];
  postalCode?: Maybe<Scalars['String']>;
  primaryApplicantBankStatementSubmittedViaOpenBanking?: Maybe<Scalars['Boolean']>;
  primaryApplicantBankStatementUploaded?: Maybe<Scalars['Boolean']>;
  primaryApplicantIDUploaded?: Maybe<Scalars['Boolean']>;
  primaryApplicantIncomeVerificationUploaded?: Maybe<Scalars['Boolean']>;
  primaryApplicantInfo?: Maybe<PrimaryApplicantInfo>;
  realtorInformation?: Maybe<RealtorInformation>;
  sampleValue?: Maybe<Scalars['Boolean']>;
  submittedInspectionReport?: Maybe<Scalars['Boolean']>;
};

export type CustomerReferralUrl = {
  __typename?: 'CustomerReferralUrl';
  originalUrl: Scalars['String'];
  shortUrl: Scalars['String'];
};

export type CustomerUploadInput = {
  content?: InputMaybe<Scalars['String']>;
  documentType: CustomerFileCategory;
  fileName: Scalars['String'];
  isForCoApplicant?: InputMaybe<Scalars['Boolean']>;
  stagingFileKey?: InputMaybe<Scalars['String']>;
};

export enum DatesToMoveIn {
  AsSoonAsPossible = 'AS_SOON_AS_POSSIBLE',
  FourMonthsPlus = 'FOUR_MONTHS_PLUS',
  NotSureYet = 'NOT_SURE_YET',
  OneToTwoMonths = 'ONE_TO_TWO_MONTHS',
  ThreeToFourMonths = 'THREE_TO_FOUR_MONTHS'
}

export type DealLegalDocument = {
  __typename?: 'DealLegalDocument';
  createdAt: Scalars['String'];
  documentType: DealLegalDocumentType;
  fileS3Key?: Maybe<Scalars['String']>;
  hsNoteId: Scalars['String'];
  hubspotFileId: Scalars['String'];
  s3Location?: Maybe<Scalars['String']>;
};

export enum DealLegalDocumentType {
  DraftCommitmentLetter = 'DRAFT_COMMITMENT_LETTER',
  DraftDisclosurePackage = 'DRAFT_DISCLOSURE_PACKAGE',
  DraftOptionToPurchaseAgreement = 'DRAFT_OPTION_TO_PURCHASE_AGREEMENT',
  DraftStandardLease = 'DRAFT_STANDARD_LEASE',
  FinalCommitmentLetter = 'FINAL_COMMITMENT_LETTER',
  FinalDisclosurePackage = 'FINAL_DISCLOSURE_PACKAGE',
  FinalOptionToPurchaseAgreement = 'FINAL_OPTION_TO_PURCHASE_AGREEMENT',
  FinalStandardLease = 'FINAL_STANDARD_LEASE'
}

export type DocumentStatus = {
  __typename?: 'DocumentStatus';
  bankStatement?: Maybe<Scalars['String']>;
  bankStatementRejection?: Maybe<Scalars['String']>;
  creditCheck?: Maybe<Scalars['String']>;
  creditCheckRejection?: Maybe<Scalars['String']>;
  employmentDocuments?: Maybe<Scalars['String']>;
  employmentDocumentsRejection?: Maybe<Scalars['String']>;
  noticeOfAssessment?: Maybe<Scalars['String']>;
  noticeOfAssessmentRejection?: Maybe<Scalars['String']>;
  otherIncomeDocuments?: Maybe<Scalars['String']>;
  otherIncomeDocumentsRejection?: Maybe<Scalars['String']>;
  proofOfId?: Maybe<Scalars['String']>;
  proofOfIdRejection?: Maybe<Scalars['String']>;
  selfEmploymentDocuments?: Maybe<Scalars['String']>;
  selfEmploymentDocumentsRejection?: Maybe<Scalars['String']>;
};

export type EmploymentDetails = {
  __typename?: 'EmploymentDetails';
  childTaxBenefit?: Maybe<Scalars['Boolean']>;
  childTaxBenefits?: Maybe<ChildTaxBenefits>;
  disabilityBenefit?: Maybe<Scalars['Boolean']>;
  homeMaker?: Maybe<Scalars['Boolean']>;
  otherIncomeSource?: Maybe<OtherIncomeSources>;
  others?: Maybe<Scalars['Boolean']>;
  pensionAndDisability?: Maybe<PensionAndDisability>;
  pensionIncome?: Maybe<Scalars['Boolean']>;
  selfEmployed?: Maybe<SelfEmployed>;
  traditionalEmployment?: Maybe<TraditionalEmployment>;
};

export type EmploymentDetailsInput = {
  childTaxBenefit?: InputMaybe<Scalars['Boolean']>;
  childTaxBenefits?: InputMaybe<ChildTaxBenefitsInput>;
  disabilityBenefit?: InputMaybe<Scalars['Boolean']>;
  homeMaker?: InputMaybe<Scalars['Boolean']>;
  otherIncomeSource?: InputMaybe<OtherIncomeSourcesInput>;
  others?: InputMaybe<Scalars['Boolean']>;
  pensionAndDisability?: InputMaybe<PensionAndDisabilityInput>;
  pensionIncome?: InputMaybe<Scalars['Boolean']>;
  selfEmployed?: InputMaybe<SelfEmployedInput>;
  traditionalEmployment?: InputMaybe<TraditionalEmploymentInput>;
};

export type EmploymentInput = {
  employmentDetails: EmploymentDetailsInput;
  forCoApplicant?: InputMaybe<Scalars['Boolean']>;
};

export type File = {
  __typename?: 'File';
  createdAt: Scalars['String'];
  documentType?: Maybe<Scalars['String']>;
  fileS3Key: Scalars['String'];
  hubspotFileId: Scalars['String'];
  isForCoApplicant?: Maybe<Scalars['Boolean']>;
  originalFileName: Scalars['String'];
  s3Location?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export enum FrequencyOfPayment {
  BiWeekly = 'BI_WEEKLY',
  Monthly = 'MONTHLY',
  Other = 'OTHER',
  SemiMonthly = 'SEMI_MONTHLY',
  Weekly = 'WEEKLY'
}

export type FullApprovalAcceptedInfo = {
  __typename?: 'FullApprovalAcceptedInfo';
  fullApprovalAcceptedHomePrice: Scalars['String'];
  fullApprovalAcceptedMinimumDownPayment: Scalars['String'];
  fullApprovalAcceptedMonthlyRent: Scalars['String'];
  fullApprovalAcceptedMonthlySavings: Scalars['String'];
};

export enum IncomeSource {
  AlimonyChildSupport = 'ALIMONY_CHILD_SUPPORT',
  Disability = 'DISABILITY',
  FullTime = 'FULL_TIME',
  Other = 'OTHER',
  PartTime = 'PART_TIME',
  Pension = 'PENSION',
  SelfEmployed = 'SELF_EMPLOYED'
}

export type Inspection = {
  __typename?: 'Inspection';
  conditionExpiryDate?: Maybe<Scalars['AWSDate']>;
  isReviewCallBooked?: Maybe<Scalars['Boolean']>;
};

export enum InternalDealStage {
  ApplicationStarted = 'APPLICATION_STARTED',
  BankStatementSubmitted = 'BANK_STATEMENT_SUBMITTED',
  EmploymentDetailsSubmitted = 'EMPLOYMENT_DETAILS_SUBMITTED',
  FullApprovalStarted = 'FULL_APPROVAL_STARTED',
  FullApprovalSubmitted = 'FULL_APPROVAL_SUBMITTED',
  IncomeVerificationDocumentsSubmitted = 'INCOME_VERIFICATION_DOCUMENTS_SUBMITTED',
  NoticeOfAssessmentSubmitted = 'NOTICE_OF_ASSESSMENT_SUBMITTED',
  OtherIncomeSourceSubmitted = 'OTHER_INCOME_SOURCE_SUBMITTED',
  PreApprovalAccepted = 'PRE_APPROVAL_ACCEPTED',
  SelfEmploymentDetailsSubmitted = 'SELF_EMPLOYMENT_DETAILS_SUBMITTED'
}

export type InviteeDetailsInput = {
  email: Scalars['String'];
  familyName: Scalars['String'];
  givenName: Scalars['String'];
  phoneNumber: Scalars['String'];
  targetCity?: InputMaybe<Scalars['String']>;
};

export type Listing = {
  __typename?: 'Listing';
  address?: Maybe<ListingAddress>;
  details?: Maybe<ListingDetails>;
  images?: Maybe<Array<Maybe<Scalars['String']>>>;
  listPrice?: Maybe<Scalars['String']>;
  mlsNumber?: Maybe<Scalars['String']>;
};

export type ListingAddress = {
  __typename?: 'ListingAddress';
  city?: Maybe<Scalars['String']>;
  neighborhood?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  streetName?: Maybe<Scalars['String']>;
  streetNumber?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type ListingDetails = {
  __typename?: 'ListingDetails';
  basement1?: Maybe<Scalars['String']>;
  basement2?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  garage?: Maybe<Scalars['String']>;
  heating?: Maybe<Scalars['String']>;
  moreInformationLink?: Maybe<Scalars['String']>;
  numBathrooms?: Maybe<Scalars['String']>;
  numBedrooms?: Maybe<Scalars['String']>;
  numParkingSpaces?: Maybe<Scalars['String']>;
  numRooms?: Maybe<Scalars['String']>;
  parkingType?: Maybe<Scalars['String']>;
  roofMaterial?: Maybe<Scalars['String']>;
  sqft?: Maybe<Scalars['String']>;
  style?: Maybe<Scalars['String']>;
  yearBuilt?: Maybe<Scalars['String']>;
};

export type MonthlyDebtBreakdown = {
  __typename?: 'MonthlyDebtBreakdown';
  carLoans?: Maybe<Scalars['Float']>;
  lineOfCredit?: Maybe<Scalars['Float']>;
  other?: Maybe<Scalars['Float']>;
  studentLoans?: Maybe<Scalars['Float']>;
};

export type MonthlyDebtBreakdownInput = {
  carLoans?: InputMaybe<Scalars['Float']>;
  lineOfCredit?: InputMaybe<Scalars['Float']>;
  other?: InputMaybe<Scalars['Float']>;
  studentLoans?: InputMaybe<Scalars['Float']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addCoApplicant: CustomerInfo;
  deleteCustomerFile?: Maybe<Scalars['String']>;
  removeCoApplicant: CustomerInfo;
  sendCoApplicantCreditReportEmail: CustomerInfo;
  sendCoApplicantIncomeVerificationEmail: CustomerInfo;
  sendCustomerToCustomerInvitation: Scalars['String'];
  submitCreditReportConsent: CustomerInfo;
  submitEmergencyContact: CustomerInfo;
  submitEmploymentDetails: PreApprovalApplication;
  submitInspectionDate: CustomerInfo;
  submitOffer: CustomerInfo;
  submitPreApproval: PreApprovalResults;
  updateApplicationStatus: Scalars['String'];
  updateBankStatementStatus: CustomerInfo;
  updateCustomerInfo?: Maybe<UpdateCustomerInfoResponse>;
  uploadCustomerFile?: Maybe<Scalars['String']>;
};


export type MutationAddCoApplicantArgs = {
  input?: InputMaybe<AddCoApplicantInput>;
};


export type MutationDeleteCustomerFileArgs = {
  hubspotFileId: Scalars['String'];
};


export type MutationSendCoApplicantCreditReportEmailArgs = {
  consent: CoApplicantCreditReportConsentInput;
};


export type MutationSendCustomerToCustomerInvitationArgs = {
  invitee: InviteeDetailsInput;
};


export type MutationSubmitCreditReportConsentArgs = {
  consent: CreditReportConsentInput;
};


export type MutationSubmitEmergencyContactArgs = {
  emergencyContactInfo: SubmitEmergencyContactInput;
};


export type MutationSubmitEmploymentDetailsArgs = {
  input: EmploymentInput;
};


export type MutationSubmitInspectionDateArgs = {
  inspectionDate: Scalars['String'];
};


export type MutationSubmitOfferArgs = {
  offer: SubmitOfferInput;
};


export type MutationSubmitPreApprovalArgs = {
  application: PreApprovalApplicationInput;
};


export type MutationUpdateApplicationStatusArgs = {
  input: ApplicationStatusInput;
};


export type MutationUpdateBankStatementStatusArgs = {
  forCoApplicant: Scalars['Boolean'];
};


export type MutationUpdateCustomerInfoArgs = {
  input: UpdateCustomerInfoInput;
};


export type MutationUploadCustomerFileArgs = {
  file: CustomerUploadInput;
};

export type OfferConditions = {
  __typename?: 'OfferConditions';
  appraisedHomeValue?: Maybe<Scalars['Float']>;
  closingDate?: Maybe<Scalars['AWSDate']>;
  closingMonth?: Maybe<Scalars['String']>;
  closingMonthRent?: Maybe<Scalars['Float']>;
  closingMonthSavings?: Maybe<Scalars['Float']>;
  remainingDownPayment?: Maybe<Scalars['Float']>;
  succeedingMonth?: Maybe<Scalars['String']>;
  succeedingMonthRent?: Maybe<Scalars['Float']>;
  succeedingMonthSavings?: Maybe<Scalars['Float']>;
};

export type OfferInformation = {
  __typename?: 'OfferInformation';
  inspectionDate?: Maybe<Scalars['String']>;
  numberOfInitiatedOffers: Scalars['Int'];
  propertyCity: Scalars['String'];
  propertyMLS?: Maybe<Scalars['String']>;
  propertyProvince: Province;
  propertyStreet: Scalars['String'];
  propertyUrl?: Maybe<Scalars['String']>;
};

export type OtherIncomeSources = {
  __typename?: 'OtherIncomeSources';
  monthlyAmount: Scalars['Float'];
  source: Scalars['String'];
};

export type OtherIncomeSourcesInput = {
  monthlyAmount: Scalars['Float'];
  source: Scalars['String'];
};

export type PensionAndDisability = {
  __typename?: 'PensionAndDisability';
  monthlyAmount: Scalars['Float'];
};

export type PensionAndDisabilityInput = {
  monthlyAmount: Scalars['Float'];
};

export type PreApprovalApplication = {
  __typename?: 'PreApprovalApplication';
  coApplicant?: Maybe<CoApplicantPreApprovalInfo>;
  currentMonthlyRent?: Maybe<Scalars['Float']>;
  hasCoApplicant: Scalars['Boolean'];
  hasRealEstateAgent?: Maybe<Scalars['Boolean']>;
  primaryApplicant: PrimaryApplicantPreApprovalInfo;
  realEstateAgentName?: Maybe<Scalars['String']>;
  targetCity: Scalars['String'];
  targetProvince: Province;
  totalSavings: Scalars['Float'];
  whenToMoveIn?: Maybe<DatesToMoveIn>;
};

export type PreApprovalApplicationInput = {
  coApplicant?: InputMaybe<CoApplicantPreApprovalInfoInput>;
  currentMonthlyRent?: InputMaybe<Scalars['Float']>;
  hasCoApplicant?: InputMaybe<Scalars['Boolean']>;
  hasRealEstateAgent?: InputMaybe<Scalars['Boolean']>;
  isOldFlow?: InputMaybe<Scalars['Boolean']>;
  primaryApplicant?: InputMaybe<PrimaryApplicantPreApprovalInfoInput>;
  realEstateAgentName?: InputMaybe<Scalars['String']>;
  step?: InputMaybe<Scalars['Int']>;
  targetCity?: InputMaybe<Scalars['String']>;
  targetProvince?: InputMaybe<Province>;
  totalSavings?: InputMaybe<Scalars['Float']>;
  whenToMoveIn?: InputMaybe<DatesToMoveIn>;
};

export type PreApprovalResults = {
  __typename?: 'PreApprovalResults';
  isApproved?: Maybe<Scalars['Boolean']>;
  maxHomePrice?: Maybe<Scalars['Float']>;
  monthlyRTOPayment?: Maybe<Scalars['Float']>;
  monthlyRent?: Maybe<Scalars['Float']>;
  monthlySavings?: Maybe<Scalars['Float']>;
  rejectionReasons?: Maybe<RejectionReasons>;
};

export type PreQualificationIncomeSourceInput = {
  childTaxBenefits?: InputMaybe<Scalars['Boolean']>;
  homeMaker?: InputMaybe<Scalars['Boolean']>;
  otherIncomeSource?: InputMaybe<Scalars['Boolean']>;
  pensionAndDisability?: InputMaybe<Scalars['Boolean']>;
  selfEmployed?: InputMaybe<Scalars['Boolean']>;
  traditionalEmployment?: InputMaybe<Scalars['Boolean']>;
};

export type PrimaryApplicantInfo = {
  __typename?: 'PrimaryApplicantInfo';
  email: Scalars['String'];
  id: Scalars['String'];
};

export type PrimaryApplicantPreApprovalInfo = {
  __typename?: 'PrimaryApplicantPreApprovalInfo';
  annualIncome: Scalars['Float'];
  creditScore?: Maybe<Scalars['Int']>;
  creditScoreKnown: Scalars['Boolean'];
  employmentDetails?: Maybe<EmploymentDetails>;
  inBankruptcy: Scalars['Boolean'];
  monthlyDebtBreakdown?: Maybe<MonthlyDebtBreakdown>;
  monthlyDebtPayments: Scalars['Float'];
  preQualificationIncomeSource?: Maybe<PreQualificationIncomeTypes>;
};

export type PrimaryApplicantPreApprovalInfoInput = {
  annualIncome?: InputMaybe<Scalars['Float']>;
  creditScore?: InputMaybe<Scalars['Int']>;
  creditScoreKnown?: InputMaybe<Scalars['Boolean']>;
  inBankruptcy?: InputMaybe<Scalars['Boolean']>;
  monthlyDebtBreakdown?: InputMaybe<MonthlyDebtBreakdownInput>;
  monthlyDebtPayments?: InputMaybe<Scalars['Float']>;
  preQualificationIncomeSource?: InputMaybe<PreQualificationIncomeSourceInput>;
};

export enum Province {
  Alberta = 'ALBERTA',
  BritishColumbia = 'BRITISH_COLUMBIA',
  Manitoba = 'MANITOBA',
  NewfoundlandLabrador = 'NEWFOUNDLAND_LABRADOR',
  NewBrunswick = 'NEW_BRUNSWICK',
  NorthwestTerritories = 'NORTHWEST_TERRITORIES',
  NovaScotia = 'NOVA_SCOTIA',
  Nunavut = 'NUNAVUT',
  Ontario = 'ONTARIO',
  PrinceEdwardIsland = 'PRINCE_EDWARD_ISLAND',
  Quebec = 'QUEBEC',
  Saskatchewan = 'SASKATCHEWAN',
  Yukon = 'YUKON'
}

export type Query = {
  __typename?: 'Query';
  customerFileUploadUrl: Scalars['AWSJSON'];
  customerFiles: CustomerInfo;
  customerInfo: CustomerInfo;
  customerLegalDocuments?: Maybe<Array<Maybe<DealLegalDocument>>>;
  customerReferralUrl: CustomerReferralUrl;
  downloadCustomerFile?: Maybe<Scalars['String']>;
  preApprovalApplication?: Maybe<PreApprovalApplication>;
  preApprovalResults?: Maybe<PreApprovalResults>;
};


export type QueryCustomerFileUploadUrlArgs = {
  fileName: Scalars['String'];
};


export type QueryDownloadCustomerFileArgs = {
  fileS3Key: Scalars['String'];
};

export type RealtorInformation = {
  __typename?: 'RealtorInformation';
  company?: Maybe<Scalars['String']>;
  contactType?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type RejectionReasons = {
  __typename?: 'RejectionReasons';
  activeBankruptcy: Scalars['Boolean'];
  creditScoreTooLow: Scalars['Boolean'];
  debtTooHigh: Scalars['Boolean'];
  homePriceTooLow: Scalars['Boolean'];
  incomeTooLow: Scalars['Boolean'];
  savingsTooLow: Scalars['Boolean'];
};

export type SelfEmployed = {
  __typename?: 'SelfEmployed';
  averageMonthlyIncome?: Maybe<Scalars['Float']>;
  businessName: Scalars['String'];
  isBusinessIncorporated: Scalars['Boolean'];
  startDate: Scalars['AWSDate'];
};

export type SelfEmployedInput = {
  averageMonthlyIncome?: InputMaybe<Scalars['Float']>;
  businessName: Scalars['String'];
  isBusinessIncorporated: Scalars['Boolean'];
  startDate: Scalars['AWSDate'];
};

export type SubmitEmergencyContactInput = {
  emergencyContactEmail: Scalars['String'];
  emergencyContactName: Scalars['String'];
  emergencyContactPhoneNumber: Scalars['String'];
  otherOccupants?: InputMaybe<Scalars['String']>;
};

export type SubmitOfferInput = {
  propertyCity: Scalars['String'];
  propertyMLS?: InputMaybe<Scalars['String']>;
  propertyProvince: Province;
  propertyStreet: Scalars['String'];
  propertyUrl?: InputMaybe<Scalars['String']>;
};

export type TraditionalEmployment = {
  __typename?: 'TraditionalEmployment';
  employerName: Scalars['String'];
  frequencyOfPayment?: Maybe<FrequencyOfPayment>;
  grossIncomePerPaycheck?: Maybe<Scalars['Float']>;
  startDate: Scalars['AWSDate'];
};

export type TraditionalEmploymentInput = {
  employerName: Scalars['String'];
  frequencyOfPayment?: InputMaybe<FrequencyOfPayment>;
  grossIncomePerPaycheck?: InputMaybe<Scalars['Float']>;
  startDate: Scalars['AWSDate'];
};

export type UpdateCustomerInfoInput = {
  currentPage?: InputMaybe<CurrentPage>;
  documentType?: InputMaybe<CustomerFileCategory>;
  hasGivenPhotoConsent?: InputMaybe<Scalars['Boolean']>;
  hasViewedPreQualificationIntro?: InputMaybe<Scalars['Boolean']>;
  isFinalStep?: InputMaybe<Scalars['Boolean']>;
  isForCoApplicant?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateCustomerInfoResponse = {
  __typename?: 'UpdateCustomerInfoResponse';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type UploadCustomerFileResults = {
  __typename?: 'UploadCustomerFileResults';
  errorMessage?: Maybe<Scalars['String']>;
  isUploaded: Scalars['Boolean'];
};

export type EmergencyContactAndOtherOccupants = {
  __typename?: 'emergencyContactAndOtherOccupants';
  emergencyContactEmail?: Maybe<Scalars['String']>;
  emergencyContactName?: Maybe<Scalars['String']>;
  emergencyContactPhoneNumber?: Maybe<Scalars['String']>;
  otherOccupants?: Maybe<Scalars['String']>;
};

export type PreQualificationIncomeTypes = {
  __typename?: 'preQualificationIncomeTypes';
  childTaxBenefits?: Maybe<Scalars['Boolean']>;
  homeMaker?: Maybe<Scalars['Boolean']>;
  otherIncomeSource?: Maybe<Scalars['Boolean']>;
  pensionAndDisability?: Maybe<Scalars['Boolean']>;
  selfEmployed?: Maybe<Scalars['Boolean']>;
  traditionalEmployment?: Maybe<Scalars['Boolean']>;
};

export type AddCoApplicantMutationVariables = Exact<{
  input: AddCoApplicantInput;
}>;


export type AddCoApplicantMutation = { __typename?: 'Mutation', addCoApplicant: { __typename?: 'CustomerInfo', coApplicant?: { __typename?: 'CoApplicantInfo', givenName: string, familyName: string, email: string } | null } };

export type DeleteCustomerFileMutationVariables = Exact<{
  hubspotFileId: Scalars['String'];
}>;


export type DeleteCustomerFileMutation = { __typename?: 'Mutation', deleteCustomerFile?: string | null };

export type RemoveCoApplicantMutationVariables = Exact<{ [key: string]: never; }>;


export type RemoveCoApplicantMutation = { __typename?: 'Mutation', removeCoApplicant: { __typename?: 'CustomerInfo', givenName: string, familyName: string } };

export type SendCoApplicantIncomeVerificationEmailMutationVariables = Exact<{ [key: string]: never; }>;


export type SendCoApplicantIncomeVerificationEmailMutation = { __typename?: 'Mutation', sendCoApplicantIncomeVerificationEmail: { __typename?: 'CustomerInfo', id: string, coApplicant?: { __typename?: 'CoApplicantInfo', givenName: string, familyName: string, email: string } | null } };

export type SendCoApplicantCreditReportEmailMutationVariables = Exact<{
  input: CoApplicantCreditReportConsentInput;
}>;


export type SendCoApplicantCreditReportEmailMutation = { __typename?: 'Mutation', sendCoApplicantCreditReportEmail: { __typename?: 'CustomerInfo', id: string, creditReportConsentGiven?: boolean | null } };

export type SendCustomerToCustomerInvitationMutationVariables = Exact<{
  invitee: InviteeDetailsInput;
}>;


export type SendCustomerToCustomerInvitationMutation = { __typename?: 'Mutation', sendCustomerToCustomerInvitation: string };

export type SubmitCreditReportConsentMutationVariables = Exact<{
  input: CreditReportConsentInput;
}>;


export type SubmitCreditReportConsentMutation = { __typename?: 'Mutation', submitCreditReportConsent: { __typename?: 'CustomerInfo', id: string, creditReportConsentGiven?: boolean | null } };

export type SubmitEmergencyContactMutationVariables = Exact<{
  emergencyContactInfo: SubmitEmergencyContactInput;
}>;


export type SubmitEmergencyContactMutation = { __typename?: 'Mutation', submitEmergencyContact: { __typename?: 'CustomerInfo', emergencyContactAndOtherOccupants?: { __typename?: 'emergencyContactAndOtherOccupants', emergencyContactName?: string | null, emergencyContactEmail?: string | null, emergencyContactPhoneNumber?: string | null, otherOccupants?: string | null } | null } };

export type SubmitEmploymentDetailsMutationVariables = Exact<{
  input: EmploymentInput;
}>;


export type SubmitEmploymentDetailsMutation = { __typename?: 'Mutation', submitEmploymentDetails: { __typename?: 'PreApprovalApplication', primaryApplicant: { __typename?: 'PrimaryApplicantPreApprovalInfo', employmentDetails?: { __typename?: 'EmploymentDetails', homeMaker?: boolean | null, traditionalEmployment?: { __typename?: 'TraditionalEmployment', employerName: string, startDate: string, grossIncomePerPaycheck?: number | null, frequencyOfPayment?: FrequencyOfPayment | null } | null, selfEmployed?: { __typename?: 'SelfEmployed', businessName: string, startDate: string, isBusinessIncorporated: boolean, averageMonthlyIncome?: number | null } | null, pensionAndDisability?: { __typename?: 'PensionAndDisability', monthlyAmount: number } | null, childTaxBenefits?: { __typename?: 'ChildTaxBenefits', monthlyAmount: number } | null, otherIncomeSource?: { __typename?: 'OtherIncomeSources', source: string, monthlyAmount: number } | null } | null }, coApplicant?: { __typename?: 'CoApplicantPreApprovalInfo', employmentDetails?: { __typename?: 'EmploymentDetails', homeMaker?: boolean | null, traditionalEmployment?: { __typename?: 'TraditionalEmployment', employerName: string, startDate: string, grossIncomePerPaycheck?: number | null, frequencyOfPayment?: FrequencyOfPayment | null } | null, selfEmployed?: { __typename?: 'SelfEmployed', businessName: string, startDate: string, isBusinessIncorporated: boolean, averageMonthlyIncome?: number | null } | null, pensionAndDisability?: { __typename?: 'PensionAndDisability', monthlyAmount: number } | null, childTaxBenefits?: { __typename?: 'ChildTaxBenefits', monthlyAmount: number } | null, otherIncomeSource?: { __typename?: 'OtherIncomeSources', source: string, monthlyAmount: number } | null } | null } | null } };

export type SubmitInspectionDateMutationVariables = Exact<{
  inspectionDate: Scalars['String'];
}>;


export type SubmitInspectionDateMutation = { __typename?: 'Mutation', submitInspectionDate: { __typename?: 'CustomerInfo', offerInformation?: { __typename?: 'OfferInformation', inspectionDate?: string | null } | null } };

export type SubmitOfferMutationVariables = Exact<{
  offer: SubmitOfferInput;
}>;


export type SubmitOfferMutation = { __typename?: 'Mutation', submitOffer: { __typename?: 'CustomerInfo', offerInformation?: { __typename?: 'OfferInformation', numberOfInitiatedOffers: number } | null } };

export type SubmitPreApprovalMutationVariables = Exact<{
  input: PreApprovalApplicationInput;
}>;


export type SubmitPreApprovalMutation = { __typename?: 'Mutation', submitPreApproval: { __typename?: 'PreApprovalResults', isApproved?: boolean | null } };

export type UpdateApplicationStatusMutationVariables = Exact<{
  input: ApplicationStatusInput;
}>;


export type UpdateApplicationStatusMutation = { __typename?: 'Mutation', updateApplicationStatus: string };

export type UpdateBankStatementStatusMutationVariables = Exact<{
  forCoApplicant: Scalars['Boolean'];
}>;


export type UpdateBankStatementStatusMutation = { __typename?: 'Mutation', updateBankStatementStatus: { __typename?: 'CustomerInfo', primaryApplicantBankStatementUploaded?: boolean | null, coApplicantBankStatementUploaded?: boolean | null } };

export type UpdateCustomerInfoMutationVariables = Exact<{
  input: UpdateCustomerInfoInput;
}>;


export type UpdateCustomerInfoMutation = { __typename?: 'Mutation', updateCustomerInfo?: { __typename?: 'UpdateCustomerInfoResponse', success: boolean } | null };

export type UploadCustomerFileMutationVariables = Exact<{
  input: CustomerUploadInput;
}>;


export type UploadCustomerFileMutation = { __typename?: 'Mutation', uploadCustomerFile?: string | null };

export type ApplicantInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type ApplicantInfoQuery = { __typename?: 'Query', customerInfo: { __typename?: 'CustomerInfo', applicationStatus: ApplicationStatus, id: string, givenName: string, familyName: string, phoneNumber: string, email: string, primaryApplicantBankStatementUploaded?: boolean | null, coApplicantBankStatementUploaded?: boolean | null, primaryApplicantIDUploaded?: boolean | null, coApplicantIDUploaded?: boolean | null, primaryApplicantIncomeVerificationUploaded?: boolean | null, coApplicantIncomeVerificationUploaded?: boolean | null, hasViewedPreQualificationIntro?: boolean | null, creditReportConsentGiven?: boolean | null, fullApprovalDeniedReason?: string | null, dropOffPage?: string | null, primaryApplicantBankStatementSubmittedViaOpenBanking?: boolean | null, coApplicantBankStatementSubmittedViaOpenBanking?: boolean | null, isCurrentUserCoApplicant?: boolean | null, coApplicantDropOffPoint?: string | null, coApplicant?: { __typename?: 'CoApplicantInfo', givenName: string, familyName: string, email: string, creditReportConsentGiven?: boolean | null } | null, fullApprovalAcceptedInfo?: { __typename?: 'FullApprovalAcceptedInfo', fullApprovalAcceptedHomePrice: string, fullApprovalAcceptedMinimumDownPayment: string, fullApprovalAcceptedMonthlyRent: string, fullApprovalAcceptedMonthlySavings: string } | null, documentStatus?: { __typename?: 'ApplicantsDocumentStatus', primaryApplicant?: { __typename?: 'DocumentStatus', proofOfId?: string | null, proofOfIdRejection?: string | null, bankStatement?: string | null, bankStatementRejection?: string | null, employmentDocuments?: string | null, employmentDocumentsRejection?: string | null, selfEmploymentDocuments?: string | null, selfEmploymentDocumentsRejection?: string | null, otherIncomeDocuments?: string | null, otherIncomeDocumentsRejection?: string | null, noticeOfAssessment?: string | null, noticeOfAssessmentRejection?: string | null, creditCheck?: string | null, creditCheckRejection?: string | null } | null, coApplicant?: { __typename?: 'DocumentStatus', proofOfId?: string | null, proofOfIdRejection?: string | null, bankStatement?: string | null, bankStatementRejection?: string | null, employmentDocuments?: string | null, employmentDocumentsRejection?: string | null, selfEmploymentDocuments?: string | null, selfEmploymentDocumentsRejection?: string | null, otherIncomeDocuments?: string | null, otherIncomeDocumentsRejection?: string | null, noticeOfAssessment?: string | null, noticeOfAssessmentRejection?: string | null, creditCheck?: string | null, creditCheckRejection?: string | null } | null } | null, realtorInformation?: { __typename?: 'RealtorInformation', givenName?: string | null, familyName?: string | null, email?: string | null, phoneNumber?: string | null, contactType?: string | null, company?: string | null } | null, offerInformation?: { __typename?: 'OfferInformation', propertyStreet: string, propertyCity: string, propertyProvince: Province, propertyMLS?: string | null, propertyUrl?: string | null, inspectionDate?: string | null } | null, inspection?: { __typename?: 'Inspection', conditionExpiryDate?: string | null, isReviewCallBooked?: boolean | null } | null, conditions?: { __typename?: 'OfferConditions', appraisedHomeValue?: number | null, remainingDownPayment?: number | null, closingMonth?: string | null, closingMonthRent?: number | null, closingMonthSavings?: number | null, succeedingMonth?: string | null, succeedingMonthRent?: number | null, succeedingMonthSavings?: number | null, closingDate?: string | null } | null, favoriteListings?: Array<{ __typename?: 'Listing', mlsNumber?: string | null, listPrice?: string | null, images?: Array<string | null> | null, address?: { __typename?: 'ListingAddress', streetName?: string | null, streetNumber?: string | null, city?: string | null, state?: string | null } | null, details?: { __typename?: 'ListingDetails', description?: string | null, garage?: string | null, moreInformationLink?: string | null, heating?: string | null, numBathrooms?: string | null, numParkingSpaces?: string | null, numBedrooms?: string | null, parkingType?: string | null, sqft?: string | null, yearBuilt?: string | null, roofMaterial?: string | null } | null } | null> | null, emergencyContactAndOtherOccupants?: { __typename?: 'emergencyContactAndOtherOccupants', emergencyContactName?: string | null, emergencyContactEmail?: string | null, emergencyContactPhoneNumber?: string | null, otherOccupants?: string | null } | null } };

export type ApplicantsEmploymentDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type ApplicantsEmploymentDetailsQuery = { __typename?: 'Query', preApprovalApplication?: { __typename?: 'PreApprovalApplication', hasCoApplicant: boolean, primaryApplicant: { __typename?: 'PrimaryApplicantPreApprovalInfo', preQualificationIncomeSource?: { __typename?: 'preQualificationIncomeTypes', traditionalEmployment?: boolean | null, selfEmployed?: boolean | null, pensionAndDisability?: boolean | null, childTaxBenefits?: boolean | null, homeMaker?: boolean | null, otherIncomeSource?: boolean | null } | null, employmentDetails?: { __typename?: 'EmploymentDetails', homeMaker?: boolean | null, pensionIncome?: boolean | null, disabilityBenefit?: boolean | null, childTaxBenefit?: boolean | null, others?: boolean | null, traditionalEmployment?: { __typename?: 'TraditionalEmployment', employerName: string, startDate: string, grossIncomePerPaycheck?: number | null, frequencyOfPayment?: FrequencyOfPayment | null } | null, selfEmployed?: { __typename?: 'SelfEmployed', businessName: string, startDate: string, isBusinessIncorporated: boolean, averageMonthlyIncome?: number | null } | null, pensionAndDisability?: { __typename?: 'PensionAndDisability', monthlyAmount: number } | null, childTaxBenefits?: { __typename?: 'ChildTaxBenefits', monthlyAmount: number } | null, otherIncomeSource?: { __typename?: 'OtherIncomeSources', source: string, monthlyAmount: number } | null } | null }, coApplicant?: { __typename?: 'CoApplicantPreApprovalInfo', employmentDetails?: { __typename?: 'EmploymentDetails', homeMaker?: boolean | null, pensionIncome?: boolean | null, disabilityBenefit?: boolean | null, childTaxBenefit?: boolean | null, others?: boolean | null, traditionalEmployment?: { __typename?: 'TraditionalEmployment', employerName: string, startDate: string, grossIncomePerPaycheck?: number | null, frequencyOfPayment?: FrequencyOfPayment | null } | null, selfEmployed?: { __typename?: 'SelfEmployed', businessName: string, startDate: string, isBusinessIncorporated: boolean, averageMonthlyIncome?: number | null } | null, pensionAndDisability?: { __typename?: 'PensionAndDisability', monthlyAmount: number } | null, childTaxBenefits?: { __typename?: 'ChildTaxBenefits', monthlyAmount: number } | null, otherIncomeSource?: { __typename?: 'OtherIncomeSources', source: string, monthlyAmount: number } | null } | null } | null } | null };

export type ApplicationDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type ApplicationDetailsQuery = { __typename?: 'Query', preApprovalApplication?: { __typename?: 'PreApprovalApplication', targetCity: string, targetProvince: Province, hasCoApplicant: boolean, totalSavings: number, whenToMoveIn?: DatesToMoveIn | null, hasRealEstateAgent?: boolean | null, realEstateAgentName?: string | null, currentMonthlyRent?: number | null, primaryApplicant: { __typename?: 'PrimaryApplicantPreApprovalInfo', annualIncome: number, monthlyDebtPayments: number, inBankruptcy: boolean, creditScoreKnown: boolean, creditScore?: number | null, preQualificationIncomeSource?: { __typename?: 'preQualificationIncomeTypes', traditionalEmployment?: boolean | null, selfEmployed?: boolean | null, pensionAndDisability?: boolean | null, childTaxBenefits?: boolean | null, homeMaker?: boolean | null, otherIncomeSource?: boolean | null } | null, employmentDetails?: { __typename?: 'EmploymentDetails', homeMaker?: boolean | null, pensionIncome?: boolean | null, disabilityBenefit?: boolean | null, childTaxBenefit?: boolean | null, others?: boolean | null, traditionalEmployment?: { __typename?: 'TraditionalEmployment', employerName: string, startDate: string, grossIncomePerPaycheck?: number | null, frequencyOfPayment?: FrequencyOfPayment | null } | null, selfEmployed?: { __typename?: 'SelfEmployed', businessName: string, startDate: string, isBusinessIncorporated: boolean, averageMonthlyIncome?: number | null } | null, pensionAndDisability?: { __typename?: 'PensionAndDisability', monthlyAmount: number } | null, childTaxBenefits?: { __typename?: 'ChildTaxBenefits', monthlyAmount: number } | null, otherIncomeSource?: { __typename?: 'OtherIncomeSources', source: string, monthlyAmount: number } | null } | null }, coApplicant?: { __typename?: 'CoApplicantPreApprovalInfo', givenName: string, familyName: string, email: string, annualIncome?: number | null, monthlyDebtPayments?: number | null, inBankruptcy?: boolean | null, creditScoreKnown?: boolean | null, creditScore?: number | null, preQualificationIncomeSource?: { __typename?: 'preQualificationIncomeTypes', traditionalEmployment?: boolean | null, selfEmployed?: boolean | null, pensionAndDisability?: boolean | null, childTaxBenefits?: boolean | null, homeMaker?: boolean | null, otherIncomeSource?: boolean | null } | null, employmentDetails?: { __typename?: 'EmploymentDetails', homeMaker?: boolean | null, pensionIncome?: boolean | null, disabilityBenefit?: boolean | null, childTaxBenefit?: boolean | null, others?: boolean | null, traditionalEmployment?: { __typename?: 'TraditionalEmployment', employerName: string, startDate: string, grossIncomePerPaycheck?: number | null, frequencyOfPayment?: FrequencyOfPayment | null } | null, selfEmployed?: { __typename?: 'SelfEmployed', businessName: string, startDate: string, isBusinessIncorporated: boolean, averageMonthlyIncome?: number | null } | null, pensionAndDisability?: { __typename?: 'PensionAndDisability', monthlyAmount: number } | null, childTaxBenefits?: { __typename?: 'ChildTaxBenefits', monthlyAmount: number } | null, otherIncomeSource?: { __typename?: 'OtherIncomeSources', source: string, monthlyAmount: number } | null } | null } | null } | null };

export type ApplicationStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type ApplicationStatusQuery = { __typename?: 'Query', customerInfo: { __typename?: 'CustomerInfo', id: string, applicationStatus: ApplicationStatus, creditReportConsentGiven?: boolean | null, bankStatementUploaded?: boolean | null, fullApprovalDeniedReason?: string | null, dropOffPage?: string | null, fullApprovalAcceptedInfo?: { __typename?: 'FullApprovalAcceptedInfo', fullApprovalAcceptedHomePrice: string, fullApprovalAcceptedMinimumDownPayment: string, fullApprovalAcceptedMonthlyRent: string, fullApprovalAcceptedMonthlySavings: string } | null } };

export type CreditConsentStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type CreditConsentStatusQuery = { __typename?: 'Query', customerInfo: { __typename?: 'CustomerInfo', id: string, creditReportConsentGiven?: boolean | null } };

export type CustomerFileUploadUrlQueryVariables = Exact<{
  fileName: Scalars['String'];
}>;


export type CustomerFileUploadUrlQuery = { __typename?: 'Query', customerFileUploadUrl: string };

export type CustomerFilesQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerFilesQuery = { __typename?: 'Query', customerFiles: { __typename?: 'CustomerInfo', fileUploads?: Array<{ __typename?: 'File', fileS3Key: string, originalFileName: string, createdAt: string, documentType?: string | null, hubspotFileId: string, isForCoApplicant?: boolean | null, s3Location?: string | null, status?: string | null } | null> | null } };

export type CustomerLegalDocumentsQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerLegalDocumentsQuery = { __typename?: 'Query', customerLegalDocuments?: Array<{ __typename?: 'DealLegalDocument', fileS3Key?: string | null, createdAt: string, documentType: DealLegalDocumentType, s3Location?: string | null } | null> | null };

export type DownloadCustomerFileQueryVariables = Exact<{
  fileS3Key: Scalars['String'];
}>;


export type DownloadCustomerFileQuery = { __typename?: 'Query', downloadCustomerFile?: string | null };

export type PreApprovalDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type PreApprovalDetailsQuery = { __typename?: 'Query', preApprovalResults?: { __typename?: 'PreApprovalResults', isApproved?: boolean | null, maxHomePrice?: number | null, monthlyRTOPayment?: number | null, monthlyRent?: number | null, monthlySavings?: number | null } | null };

export type CustomerReferralUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerReferralUrlQuery = { __typename?: 'Query', customerReferralUrl: { __typename?: 'CustomerReferralUrl', shortUrl: string, originalUrl: string } };

export type RejectionReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type RejectionReasonsQuery = { __typename?: 'Query', preApprovalResults?: { __typename?: 'PreApprovalResults', rejectionReasons?: { __typename?: 'RejectionReasons', activeBankruptcy: boolean, creditScoreTooLow: boolean, debtTooHigh: boolean, homePriceTooLow: boolean, incomeTooLow: boolean, savingsTooLow: boolean } | null } | null };


export const AddCoApplicantDocument = gql`
    mutation AddCoApplicant($input: AddCoApplicantInput!) {
  addCoApplicant(input: $input) {
    coApplicant {
      givenName
      familyName
      email
    }
  }
}
    `;
export type AddCoApplicantMutationFn = Apollo.MutationFunction<AddCoApplicantMutation, AddCoApplicantMutationVariables>;

/**
 * __useAddCoApplicantMutation__
 *
 * To run a mutation, you first call `useAddCoApplicantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCoApplicantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCoApplicantMutation, { data, loading, error }] = useAddCoApplicantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCoApplicantMutation(baseOptions?: Apollo.MutationHookOptions<AddCoApplicantMutation, AddCoApplicantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCoApplicantMutation, AddCoApplicantMutationVariables>(AddCoApplicantDocument, options);
      }
export type AddCoApplicantMutationHookResult = ReturnType<typeof useAddCoApplicantMutation>;
export type AddCoApplicantMutationResult = Apollo.MutationResult<AddCoApplicantMutation>;
export type AddCoApplicantMutationOptions = Apollo.BaseMutationOptions<AddCoApplicantMutation, AddCoApplicantMutationVariables>;
export const DeleteCustomerFileDocument = gql`
    mutation DeleteCustomerFile($hubspotFileId: String!) {
  deleteCustomerFile(hubspotFileId: $hubspotFileId)
}
    `;
export type DeleteCustomerFileMutationFn = Apollo.MutationFunction<DeleteCustomerFileMutation, DeleteCustomerFileMutationVariables>;

/**
 * __useDeleteCustomerFileMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomerFileMutation, { data, loading, error }] = useDeleteCustomerFileMutation({
 *   variables: {
 *      hubspotFileId: // value for 'hubspotFileId'
 *   },
 * });
 */
export function useDeleteCustomerFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomerFileMutation, DeleteCustomerFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomerFileMutation, DeleteCustomerFileMutationVariables>(DeleteCustomerFileDocument, options);
      }
export type DeleteCustomerFileMutationHookResult = ReturnType<typeof useDeleteCustomerFileMutation>;
export type DeleteCustomerFileMutationResult = Apollo.MutationResult<DeleteCustomerFileMutation>;
export type DeleteCustomerFileMutationOptions = Apollo.BaseMutationOptions<DeleteCustomerFileMutation, DeleteCustomerFileMutationVariables>;
export const RemoveCoApplicantDocument = gql`
    mutation RemoveCoApplicant {
  removeCoApplicant {
    givenName
    familyName
  }
}
    `;
export type RemoveCoApplicantMutationFn = Apollo.MutationFunction<RemoveCoApplicantMutation, RemoveCoApplicantMutationVariables>;

/**
 * __useRemoveCoApplicantMutation__
 *
 * To run a mutation, you first call `useRemoveCoApplicantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCoApplicantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCoApplicantMutation, { data, loading, error }] = useRemoveCoApplicantMutation({
 *   variables: {
 *   },
 * });
 */
export function useRemoveCoApplicantMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCoApplicantMutation, RemoveCoApplicantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCoApplicantMutation, RemoveCoApplicantMutationVariables>(RemoveCoApplicantDocument, options);
      }
export type RemoveCoApplicantMutationHookResult = ReturnType<typeof useRemoveCoApplicantMutation>;
export type RemoveCoApplicantMutationResult = Apollo.MutationResult<RemoveCoApplicantMutation>;
export type RemoveCoApplicantMutationOptions = Apollo.BaseMutationOptions<RemoveCoApplicantMutation, RemoveCoApplicantMutationVariables>;
export const SendCoApplicantIncomeVerificationEmailDocument = gql`
    mutation SendCoApplicantIncomeVerificationEmail {
  sendCoApplicantIncomeVerificationEmail {
    id
    coApplicant {
      givenName
      familyName
      email
    }
  }
}
    `;
export type SendCoApplicantIncomeVerificationEmailMutationFn = Apollo.MutationFunction<SendCoApplicantIncomeVerificationEmailMutation, SendCoApplicantIncomeVerificationEmailMutationVariables>;

/**
 * __useSendCoApplicantIncomeVerificationEmailMutation__
 *
 * To run a mutation, you first call `useSendCoApplicantIncomeVerificationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCoApplicantIncomeVerificationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCoApplicantIncomeVerificationEmailMutation, { data, loading, error }] = useSendCoApplicantIncomeVerificationEmailMutation({
 *   variables: {
 *   },
 * });
 */
export function useSendCoApplicantIncomeVerificationEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendCoApplicantIncomeVerificationEmailMutation, SendCoApplicantIncomeVerificationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendCoApplicantIncomeVerificationEmailMutation, SendCoApplicantIncomeVerificationEmailMutationVariables>(SendCoApplicantIncomeVerificationEmailDocument, options);
      }
export type SendCoApplicantIncomeVerificationEmailMutationHookResult = ReturnType<typeof useSendCoApplicantIncomeVerificationEmailMutation>;
export type SendCoApplicantIncomeVerificationEmailMutationResult = Apollo.MutationResult<SendCoApplicantIncomeVerificationEmailMutation>;
export type SendCoApplicantIncomeVerificationEmailMutationOptions = Apollo.BaseMutationOptions<SendCoApplicantIncomeVerificationEmailMutation, SendCoApplicantIncomeVerificationEmailMutationVariables>;
export const SendCoApplicantCreditReportEmailDocument = gql`
    mutation SendCoApplicantCreditReportEmail($input: CoApplicantCreditReportConsentInput!) {
  sendCoApplicantCreditReportEmail(consent: $input) {
    id
    creditReportConsentGiven
  }
}
    `;
export type SendCoApplicantCreditReportEmailMutationFn = Apollo.MutationFunction<SendCoApplicantCreditReportEmailMutation, SendCoApplicantCreditReportEmailMutationVariables>;

/**
 * __useSendCoApplicantCreditReportEmailMutation__
 *
 * To run a mutation, you first call `useSendCoApplicantCreditReportEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCoApplicantCreditReportEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCoApplicantCreditReportEmailMutation, { data, loading, error }] = useSendCoApplicantCreditReportEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendCoApplicantCreditReportEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendCoApplicantCreditReportEmailMutation, SendCoApplicantCreditReportEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendCoApplicantCreditReportEmailMutation, SendCoApplicantCreditReportEmailMutationVariables>(SendCoApplicantCreditReportEmailDocument, options);
      }
export type SendCoApplicantCreditReportEmailMutationHookResult = ReturnType<typeof useSendCoApplicantCreditReportEmailMutation>;
export type SendCoApplicantCreditReportEmailMutationResult = Apollo.MutationResult<SendCoApplicantCreditReportEmailMutation>;
export type SendCoApplicantCreditReportEmailMutationOptions = Apollo.BaseMutationOptions<SendCoApplicantCreditReportEmailMutation, SendCoApplicantCreditReportEmailMutationVariables>;
export const SendCustomerToCustomerInvitationDocument = gql`
    mutation sendCustomerToCustomerInvitation($invitee: InviteeDetailsInput!) {
  sendCustomerToCustomerInvitation(invitee: $invitee)
}
    `;
export type SendCustomerToCustomerInvitationMutationFn = Apollo.MutationFunction<SendCustomerToCustomerInvitationMutation, SendCustomerToCustomerInvitationMutationVariables>;

/**
 * __useSendCustomerToCustomerInvitationMutation__
 *
 * To run a mutation, you first call `useSendCustomerToCustomerInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCustomerToCustomerInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCustomerToCustomerInvitationMutation, { data, loading, error }] = useSendCustomerToCustomerInvitationMutation({
 *   variables: {
 *      invitee: // value for 'invitee'
 *   },
 * });
 */
export function useSendCustomerToCustomerInvitationMutation(baseOptions?: Apollo.MutationHookOptions<SendCustomerToCustomerInvitationMutation, SendCustomerToCustomerInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendCustomerToCustomerInvitationMutation, SendCustomerToCustomerInvitationMutationVariables>(SendCustomerToCustomerInvitationDocument, options);
      }
export type SendCustomerToCustomerInvitationMutationHookResult = ReturnType<typeof useSendCustomerToCustomerInvitationMutation>;
export type SendCustomerToCustomerInvitationMutationResult = Apollo.MutationResult<SendCustomerToCustomerInvitationMutation>;
export type SendCustomerToCustomerInvitationMutationOptions = Apollo.BaseMutationOptions<SendCustomerToCustomerInvitationMutation, SendCustomerToCustomerInvitationMutationVariables>;
export const SubmitCreditReportConsentDocument = gql`
    mutation SubmitCreditReportConsent($input: CreditReportConsentInput!) {
  submitCreditReportConsent(consent: $input) {
    id
    creditReportConsentGiven
  }
}
    `;
export type SubmitCreditReportConsentMutationFn = Apollo.MutationFunction<SubmitCreditReportConsentMutation, SubmitCreditReportConsentMutationVariables>;

/**
 * __useSubmitCreditReportConsentMutation__
 *
 * To run a mutation, you first call `useSubmitCreditReportConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitCreditReportConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitCreditReportConsentMutation, { data, loading, error }] = useSubmitCreditReportConsentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitCreditReportConsentMutation(baseOptions?: Apollo.MutationHookOptions<SubmitCreditReportConsentMutation, SubmitCreditReportConsentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitCreditReportConsentMutation, SubmitCreditReportConsentMutationVariables>(SubmitCreditReportConsentDocument, options);
      }
export type SubmitCreditReportConsentMutationHookResult = ReturnType<typeof useSubmitCreditReportConsentMutation>;
export type SubmitCreditReportConsentMutationResult = Apollo.MutationResult<SubmitCreditReportConsentMutation>;
export type SubmitCreditReportConsentMutationOptions = Apollo.BaseMutationOptions<SubmitCreditReportConsentMutation, SubmitCreditReportConsentMutationVariables>;
export const SubmitEmergencyContactDocument = gql`
    mutation SubmitEmergencyContact($emergencyContactInfo: SubmitEmergencyContactInput!) {
  submitEmergencyContact(emergencyContactInfo: $emergencyContactInfo) {
    emergencyContactAndOtherOccupants {
      emergencyContactName
      emergencyContactEmail
      emergencyContactPhoneNumber
      otherOccupants
    }
  }
}
    `;
export type SubmitEmergencyContactMutationFn = Apollo.MutationFunction<SubmitEmergencyContactMutation, SubmitEmergencyContactMutationVariables>;

/**
 * __useSubmitEmergencyContactMutation__
 *
 * To run a mutation, you first call `useSubmitEmergencyContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitEmergencyContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitEmergencyContactMutation, { data, loading, error }] = useSubmitEmergencyContactMutation({
 *   variables: {
 *      emergencyContactInfo: // value for 'emergencyContactInfo'
 *   },
 * });
 */
export function useSubmitEmergencyContactMutation(baseOptions?: Apollo.MutationHookOptions<SubmitEmergencyContactMutation, SubmitEmergencyContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitEmergencyContactMutation, SubmitEmergencyContactMutationVariables>(SubmitEmergencyContactDocument, options);
      }
export type SubmitEmergencyContactMutationHookResult = ReturnType<typeof useSubmitEmergencyContactMutation>;
export type SubmitEmergencyContactMutationResult = Apollo.MutationResult<SubmitEmergencyContactMutation>;
export type SubmitEmergencyContactMutationOptions = Apollo.BaseMutationOptions<SubmitEmergencyContactMutation, SubmitEmergencyContactMutationVariables>;
export const SubmitEmploymentDetailsDocument = gql`
    mutation submitEmploymentDetails($input: EmploymentInput!) {
  submitEmploymentDetails(input: $input) {
    primaryApplicant {
      employmentDetails {
        traditionalEmployment {
          employerName
          startDate
          grossIncomePerPaycheck
          frequencyOfPayment
        }
        selfEmployed {
          businessName
          startDate
          isBusinessIncorporated
          averageMonthlyIncome
        }
        pensionAndDisability {
          monthlyAmount
        }
        childTaxBenefits {
          monthlyAmount
        }
        homeMaker
        otherIncomeSource {
          source
          monthlyAmount
        }
      }
    }
    coApplicant {
      employmentDetails {
        traditionalEmployment {
          employerName
          startDate
          grossIncomePerPaycheck
          frequencyOfPayment
        }
        selfEmployed {
          businessName
          startDate
          isBusinessIncorporated
          averageMonthlyIncome
        }
        pensionAndDisability {
          monthlyAmount
        }
        childTaxBenefits {
          monthlyAmount
        }
        homeMaker
        otherIncomeSource {
          source
          monthlyAmount
        }
      }
    }
  }
}
    `;
export type SubmitEmploymentDetailsMutationFn = Apollo.MutationFunction<SubmitEmploymentDetailsMutation, SubmitEmploymentDetailsMutationVariables>;

/**
 * __useSubmitEmploymentDetailsMutation__
 *
 * To run a mutation, you first call `useSubmitEmploymentDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitEmploymentDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitEmploymentDetailsMutation, { data, loading, error }] = useSubmitEmploymentDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitEmploymentDetailsMutation(baseOptions?: Apollo.MutationHookOptions<SubmitEmploymentDetailsMutation, SubmitEmploymentDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitEmploymentDetailsMutation, SubmitEmploymentDetailsMutationVariables>(SubmitEmploymentDetailsDocument, options);
      }
export type SubmitEmploymentDetailsMutationHookResult = ReturnType<typeof useSubmitEmploymentDetailsMutation>;
export type SubmitEmploymentDetailsMutationResult = Apollo.MutationResult<SubmitEmploymentDetailsMutation>;
export type SubmitEmploymentDetailsMutationOptions = Apollo.BaseMutationOptions<SubmitEmploymentDetailsMutation, SubmitEmploymentDetailsMutationVariables>;
export const SubmitInspectionDateDocument = gql`
    mutation SubmitInspectionDate($inspectionDate: String!) {
  submitInspectionDate(inspectionDate: $inspectionDate) {
    offerInformation {
      inspectionDate
    }
  }
}
    `;
export type SubmitInspectionDateMutationFn = Apollo.MutationFunction<SubmitInspectionDateMutation, SubmitInspectionDateMutationVariables>;

/**
 * __useSubmitInspectionDateMutation__
 *
 * To run a mutation, you first call `useSubmitInspectionDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitInspectionDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitInspectionDateMutation, { data, loading, error }] = useSubmitInspectionDateMutation({
 *   variables: {
 *      inspectionDate: // value for 'inspectionDate'
 *   },
 * });
 */
export function useSubmitInspectionDateMutation(baseOptions?: Apollo.MutationHookOptions<SubmitInspectionDateMutation, SubmitInspectionDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitInspectionDateMutation, SubmitInspectionDateMutationVariables>(SubmitInspectionDateDocument, options);
      }
export type SubmitInspectionDateMutationHookResult = ReturnType<typeof useSubmitInspectionDateMutation>;
export type SubmitInspectionDateMutationResult = Apollo.MutationResult<SubmitInspectionDateMutation>;
export type SubmitInspectionDateMutationOptions = Apollo.BaseMutationOptions<SubmitInspectionDateMutation, SubmitInspectionDateMutationVariables>;
export const SubmitOfferDocument = gql`
    mutation SubmitOffer($offer: SubmitOfferInput!) {
  submitOffer(offer: $offer) {
    offerInformation {
      numberOfInitiatedOffers
    }
  }
}
    `;
export type SubmitOfferMutationFn = Apollo.MutationFunction<SubmitOfferMutation, SubmitOfferMutationVariables>;

/**
 * __useSubmitOfferMutation__
 *
 * To run a mutation, you first call `useSubmitOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitOfferMutation, { data, loading, error }] = useSubmitOfferMutation({
 *   variables: {
 *      offer: // value for 'offer'
 *   },
 * });
 */
export function useSubmitOfferMutation(baseOptions?: Apollo.MutationHookOptions<SubmitOfferMutation, SubmitOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitOfferMutation, SubmitOfferMutationVariables>(SubmitOfferDocument, options);
      }
export type SubmitOfferMutationHookResult = ReturnType<typeof useSubmitOfferMutation>;
export type SubmitOfferMutationResult = Apollo.MutationResult<SubmitOfferMutation>;
export type SubmitOfferMutationOptions = Apollo.BaseMutationOptions<SubmitOfferMutation, SubmitOfferMutationVariables>;
export const SubmitPreApprovalDocument = gql`
    mutation SubmitPreApproval($input: PreApprovalApplicationInput!) {
  submitPreApproval(application: $input) {
    isApproved
  }
}
    `;
export type SubmitPreApprovalMutationFn = Apollo.MutationFunction<SubmitPreApprovalMutation, SubmitPreApprovalMutationVariables>;

/**
 * __useSubmitPreApprovalMutation__
 *
 * To run a mutation, you first call `useSubmitPreApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitPreApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitPreApprovalMutation, { data, loading, error }] = useSubmitPreApprovalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitPreApprovalMutation(baseOptions?: Apollo.MutationHookOptions<SubmitPreApprovalMutation, SubmitPreApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitPreApprovalMutation, SubmitPreApprovalMutationVariables>(SubmitPreApprovalDocument, options);
      }
export type SubmitPreApprovalMutationHookResult = ReturnType<typeof useSubmitPreApprovalMutation>;
export type SubmitPreApprovalMutationResult = Apollo.MutationResult<SubmitPreApprovalMutation>;
export type SubmitPreApprovalMutationOptions = Apollo.BaseMutationOptions<SubmitPreApprovalMutation, SubmitPreApprovalMutationVariables>;
export const UpdateApplicationStatusDocument = gql`
    mutation updateApplicationStatus($input: ApplicationStatusInput!) {
  updateApplicationStatus(input: $input)
}
    `;
export type UpdateApplicationStatusMutationFn = Apollo.MutationFunction<UpdateApplicationStatusMutation, UpdateApplicationStatusMutationVariables>;

/**
 * __useUpdateApplicationStatusMutation__
 *
 * To run a mutation, you first call `useUpdateApplicationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApplicationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApplicationStatusMutation, { data, loading, error }] = useUpdateApplicationStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateApplicationStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateApplicationStatusMutation, UpdateApplicationStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateApplicationStatusMutation, UpdateApplicationStatusMutationVariables>(UpdateApplicationStatusDocument, options);
      }
export type UpdateApplicationStatusMutationHookResult = ReturnType<typeof useUpdateApplicationStatusMutation>;
export type UpdateApplicationStatusMutationResult = Apollo.MutationResult<UpdateApplicationStatusMutation>;
export type UpdateApplicationStatusMutationOptions = Apollo.BaseMutationOptions<UpdateApplicationStatusMutation, UpdateApplicationStatusMutationVariables>;
export const UpdateBankStatementStatusDocument = gql`
    mutation updateBankStatementStatus($forCoApplicant: Boolean!) {
  updateBankStatementStatus(forCoApplicant: $forCoApplicant) {
    primaryApplicantBankStatementUploaded
    coApplicantBankStatementUploaded
  }
}
    `;
export type UpdateBankStatementStatusMutationFn = Apollo.MutationFunction<UpdateBankStatementStatusMutation, UpdateBankStatementStatusMutationVariables>;

/**
 * __useUpdateBankStatementStatusMutation__
 *
 * To run a mutation, you first call `useUpdateBankStatementStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBankStatementStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBankStatementStatusMutation, { data, loading, error }] = useUpdateBankStatementStatusMutation({
 *   variables: {
 *      forCoApplicant: // value for 'forCoApplicant'
 *   },
 * });
 */
export function useUpdateBankStatementStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBankStatementStatusMutation, UpdateBankStatementStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBankStatementStatusMutation, UpdateBankStatementStatusMutationVariables>(UpdateBankStatementStatusDocument, options);
      }
export type UpdateBankStatementStatusMutationHookResult = ReturnType<typeof useUpdateBankStatementStatusMutation>;
export type UpdateBankStatementStatusMutationResult = Apollo.MutationResult<UpdateBankStatementStatusMutation>;
export type UpdateBankStatementStatusMutationOptions = Apollo.BaseMutationOptions<UpdateBankStatementStatusMutation, UpdateBankStatementStatusMutationVariables>;
export const UpdateCustomerInfoDocument = gql`
    mutation UpdateCustomerInfo($input: UpdateCustomerInfoInput!) {
  updateCustomerInfo(input: $input) {
    success
  }
}
    `;
export type UpdateCustomerInfoMutationFn = Apollo.MutationFunction<UpdateCustomerInfoMutation, UpdateCustomerInfoMutationVariables>;

/**
 * __useUpdateCustomerInfoMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerInfoMutation, { data, loading, error }] = useUpdateCustomerInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerInfoMutation, UpdateCustomerInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerInfoMutation, UpdateCustomerInfoMutationVariables>(UpdateCustomerInfoDocument, options);
      }
export type UpdateCustomerInfoMutationHookResult = ReturnType<typeof useUpdateCustomerInfoMutation>;
export type UpdateCustomerInfoMutationResult = Apollo.MutationResult<UpdateCustomerInfoMutation>;
export type UpdateCustomerInfoMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerInfoMutation, UpdateCustomerInfoMutationVariables>;
export const UploadCustomerFileDocument = gql`
    mutation UploadCustomerFile($input: CustomerUploadInput!) {
  uploadCustomerFile(file: $input)
}
    `;
export type UploadCustomerFileMutationFn = Apollo.MutationFunction<UploadCustomerFileMutation, UploadCustomerFileMutationVariables>;

/**
 * __useUploadCustomerFileMutation__
 *
 * To run a mutation, you first call `useUploadCustomerFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadCustomerFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadCustomerFileMutation, { data, loading, error }] = useUploadCustomerFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadCustomerFileMutation(baseOptions?: Apollo.MutationHookOptions<UploadCustomerFileMutation, UploadCustomerFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadCustomerFileMutation, UploadCustomerFileMutationVariables>(UploadCustomerFileDocument, options);
      }
export type UploadCustomerFileMutationHookResult = ReturnType<typeof useUploadCustomerFileMutation>;
export type UploadCustomerFileMutationResult = Apollo.MutationResult<UploadCustomerFileMutation>;
export type UploadCustomerFileMutationOptions = Apollo.BaseMutationOptions<UploadCustomerFileMutation, UploadCustomerFileMutationVariables>;
export const ApplicantInfoDocument = gql`
    query ApplicantInfo {
  customerInfo {
    applicationStatus
    id
    givenName
    familyName
    phoneNumber
    email
    primaryApplicantBankStatementUploaded
    coApplicantBankStatementUploaded
    primaryApplicantIDUploaded
    coApplicantIDUploaded
    primaryApplicantIncomeVerificationUploaded
    coApplicantIncomeVerificationUploaded
    hasViewedPreQualificationIntro
    creditReportConsentGiven
    coApplicant {
      givenName
      familyName
      email
      creditReportConsentGiven
    }
    fullApprovalDeniedReason
    fullApprovalAcceptedInfo {
      fullApprovalAcceptedHomePrice
      fullApprovalAcceptedMinimumDownPayment
      fullApprovalAcceptedMonthlyRent
      fullApprovalAcceptedMonthlySavings
    }
    dropOffPage
    documentStatus {
      primaryApplicant {
        proofOfId
        proofOfIdRejection
        bankStatement
        bankStatementRejection
        employmentDocuments
        employmentDocumentsRejection
        selfEmploymentDocuments
        selfEmploymentDocumentsRejection
        otherIncomeDocuments
        otherIncomeDocumentsRejection
        noticeOfAssessment
        noticeOfAssessmentRejection
        creditCheck
        creditCheckRejection
      }
      coApplicant {
        proofOfId
        proofOfIdRejection
        bankStatement
        bankStatementRejection
        employmentDocuments
        employmentDocumentsRejection
        selfEmploymentDocuments
        selfEmploymentDocumentsRejection
        otherIncomeDocuments
        otherIncomeDocumentsRejection
        noticeOfAssessment
        noticeOfAssessmentRejection
        creditCheck
        creditCheckRejection
      }
    }
    realtorInformation {
      givenName
      familyName
      email
      phoneNumber
      contactType
      company
    }
    offerInformation {
      propertyStreet
      propertyCity
      propertyProvince
      propertyMLS
      propertyUrl
      inspectionDate
    }
    inspection {
      conditionExpiryDate
      isReviewCallBooked
    }
    conditions {
      appraisedHomeValue
      remainingDownPayment
      closingMonth
      closingMonthRent
      closingMonthSavings
      succeedingMonth
      succeedingMonthRent
      succeedingMonthSavings
      closingDate
    }
    primaryApplicantBankStatementSubmittedViaOpenBanking
    coApplicantBankStatementSubmittedViaOpenBanking
    isCurrentUserCoApplicant
    coApplicantDropOffPoint
    favoriteListings {
      mlsNumber
      listPrice
      images
      address {
        streetName
        streetNumber
        city
        state
      }
      details {
        description
        garage
        moreInformationLink
        heating
        numBathrooms
        numParkingSpaces
        numBedrooms
        parkingType
        sqft
        yearBuilt
        roofMaterial
      }
    }
    emergencyContactAndOtherOccupants {
      emergencyContactName
      emergencyContactEmail
      emergencyContactPhoneNumber
      otherOccupants
    }
  }
}
    `;

/**
 * __useApplicantInfoQuery__
 *
 * To run a query within a React component, call `useApplicantInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicantInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicantInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useApplicantInfoQuery(baseOptions?: Apollo.QueryHookOptions<ApplicantInfoQuery, ApplicantInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicantInfoQuery, ApplicantInfoQueryVariables>(ApplicantInfoDocument, options);
      }
export function useApplicantInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicantInfoQuery, ApplicantInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicantInfoQuery, ApplicantInfoQueryVariables>(ApplicantInfoDocument, options);
        }
export type ApplicantInfoQueryHookResult = ReturnType<typeof useApplicantInfoQuery>;
export type ApplicantInfoLazyQueryHookResult = ReturnType<typeof useApplicantInfoLazyQuery>;
export type ApplicantInfoQueryResult = Apollo.QueryResult<ApplicantInfoQuery, ApplicantInfoQueryVariables>;
export const ApplicantsEmploymentDetailsDocument = gql`
    query ApplicantsEmploymentDetails {
  preApprovalApplication {
    hasCoApplicant
    primaryApplicant {
      preQualificationIncomeSource {
        traditionalEmployment
        selfEmployed
        pensionAndDisability
        childTaxBenefits
        homeMaker
        otherIncomeSource
      }
      employmentDetails {
        traditionalEmployment {
          employerName
          startDate
          grossIncomePerPaycheck
          frequencyOfPayment
        }
        selfEmployed {
          businessName
          startDate
          isBusinessIncorporated
          averageMonthlyIncome
        }
        pensionAndDisability {
          monthlyAmount
        }
        childTaxBenefits {
          monthlyAmount
        }
        homeMaker
        otherIncomeSource {
          source
          monthlyAmount
        }
        pensionIncome
        disabilityBenefit
        childTaxBenefit
        others
      }
    }
    coApplicant {
      employmentDetails {
        traditionalEmployment {
          employerName
          startDate
          grossIncomePerPaycheck
          frequencyOfPayment
        }
        selfEmployed {
          businessName
          startDate
          isBusinessIncorporated
          averageMonthlyIncome
        }
        pensionAndDisability {
          monthlyAmount
        }
        childTaxBenefits {
          monthlyAmount
        }
        homeMaker
        otherIncomeSource {
          source
          monthlyAmount
        }
        pensionIncome
        disabilityBenefit
        childTaxBenefit
        others
      }
    }
  }
}
    `;

/**
 * __useApplicantsEmploymentDetailsQuery__
 *
 * To run a query within a React component, call `useApplicantsEmploymentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicantsEmploymentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicantsEmploymentDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useApplicantsEmploymentDetailsQuery(baseOptions?: Apollo.QueryHookOptions<ApplicantsEmploymentDetailsQuery, ApplicantsEmploymentDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicantsEmploymentDetailsQuery, ApplicantsEmploymentDetailsQueryVariables>(ApplicantsEmploymentDetailsDocument, options);
      }
export function useApplicantsEmploymentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicantsEmploymentDetailsQuery, ApplicantsEmploymentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicantsEmploymentDetailsQuery, ApplicantsEmploymentDetailsQueryVariables>(ApplicantsEmploymentDetailsDocument, options);
        }
export type ApplicantsEmploymentDetailsQueryHookResult = ReturnType<typeof useApplicantsEmploymentDetailsQuery>;
export type ApplicantsEmploymentDetailsLazyQueryHookResult = ReturnType<typeof useApplicantsEmploymentDetailsLazyQuery>;
export type ApplicantsEmploymentDetailsQueryResult = Apollo.QueryResult<ApplicantsEmploymentDetailsQuery, ApplicantsEmploymentDetailsQueryVariables>;
export const ApplicationDetailsDocument = gql`
    query ApplicationDetails {
  preApprovalApplication {
    targetCity
    targetProvince
    hasCoApplicant
    totalSavings
    whenToMoveIn
    hasRealEstateAgent
    realEstateAgentName
    currentMonthlyRent
    primaryApplicant {
      annualIncome
      monthlyDebtPayments
      inBankruptcy
      creditScoreKnown
      creditScore
      preQualificationIncomeSource {
        traditionalEmployment
        selfEmployed
        pensionAndDisability
        childTaxBenefits
        homeMaker
        otherIncomeSource
      }
      employmentDetails {
        traditionalEmployment {
          employerName
          startDate
          grossIncomePerPaycheck
          frequencyOfPayment
        }
        selfEmployed {
          businessName
          startDate
          isBusinessIncorporated
          averageMonthlyIncome
        }
        pensionAndDisability {
          monthlyAmount
        }
        childTaxBenefits {
          monthlyAmount
        }
        homeMaker
        otherIncomeSource {
          source
          monthlyAmount
        }
        pensionIncome
        disabilityBenefit
        childTaxBenefit
        others
      }
    }
    coApplicant {
      givenName
      familyName
      email
      annualIncome
      monthlyDebtPayments
      inBankruptcy
      creditScoreKnown
      creditScore
      preQualificationIncomeSource {
        traditionalEmployment
        selfEmployed
        pensionAndDisability
        childTaxBenefits
        homeMaker
        otherIncomeSource
      }
      employmentDetails {
        traditionalEmployment {
          employerName
          startDate
          grossIncomePerPaycheck
          frequencyOfPayment
        }
        selfEmployed {
          businessName
          startDate
          isBusinessIncorporated
          averageMonthlyIncome
        }
        pensionAndDisability {
          monthlyAmount
        }
        childTaxBenefits {
          monthlyAmount
        }
        homeMaker
        otherIncomeSource {
          source
          monthlyAmount
        }
        pensionIncome
        disabilityBenefit
        childTaxBenefit
        others
      }
    }
  }
}
    `;

/**
 * __useApplicationDetailsQuery__
 *
 * To run a query within a React component, call `useApplicationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useApplicationDetailsQuery(baseOptions?: Apollo.QueryHookOptions<ApplicationDetailsQuery, ApplicationDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationDetailsQuery, ApplicationDetailsQueryVariables>(ApplicationDetailsDocument, options);
      }
export function useApplicationDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationDetailsQuery, ApplicationDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationDetailsQuery, ApplicationDetailsQueryVariables>(ApplicationDetailsDocument, options);
        }
export type ApplicationDetailsQueryHookResult = ReturnType<typeof useApplicationDetailsQuery>;
export type ApplicationDetailsLazyQueryHookResult = ReturnType<typeof useApplicationDetailsLazyQuery>;
export type ApplicationDetailsQueryResult = Apollo.QueryResult<ApplicationDetailsQuery, ApplicationDetailsQueryVariables>;
export const ApplicationStatusDocument = gql`
    query ApplicationStatus {
  customerInfo {
    id
    applicationStatus
    creditReportConsentGiven
    bankStatementUploaded
    fullApprovalDeniedReason
    fullApprovalAcceptedInfo {
      fullApprovalAcceptedHomePrice
      fullApprovalAcceptedMinimumDownPayment
      fullApprovalAcceptedMonthlyRent
      fullApprovalAcceptedMonthlySavings
    }
    dropOffPage
  }
}
    `;

/**
 * __useApplicationStatusQuery__
 *
 * To run a query within a React component, call `useApplicationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useApplicationStatusQuery(baseOptions?: Apollo.QueryHookOptions<ApplicationStatusQuery, ApplicationStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationStatusQuery, ApplicationStatusQueryVariables>(ApplicationStatusDocument, options);
      }
export function useApplicationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationStatusQuery, ApplicationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationStatusQuery, ApplicationStatusQueryVariables>(ApplicationStatusDocument, options);
        }
export type ApplicationStatusQueryHookResult = ReturnType<typeof useApplicationStatusQuery>;
export type ApplicationStatusLazyQueryHookResult = ReturnType<typeof useApplicationStatusLazyQuery>;
export type ApplicationStatusQueryResult = Apollo.QueryResult<ApplicationStatusQuery, ApplicationStatusQueryVariables>;
export const CreditConsentStatusDocument = gql`
    query CreditConsentStatus {
  customerInfo {
    id
    creditReportConsentGiven
  }
}
    `;

/**
 * __useCreditConsentStatusQuery__
 *
 * To run a query within a React component, call `useCreditConsentStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreditConsentStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditConsentStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreditConsentStatusQuery(baseOptions?: Apollo.QueryHookOptions<CreditConsentStatusQuery, CreditConsentStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreditConsentStatusQuery, CreditConsentStatusQueryVariables>(CreditConsentStatusDocument, options);
      }
export function useCreditConsentStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreditConsentStatusQuery, CreditConsentStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreditConsentStatusQuery, CreditConsentStatusQueryVariables>(CreditConsentStatusDocument, options);
        }
export type CreditConsentStatusQueryHookResult = ReturnType<typeof useCreditConsentStatusQuery>;
export type CreditConsentStatusLazyQueryHookResult = ReturnType<typeof useCreditConsentStatusLazyQuery>;
export type CreditConsentStatusQueryResult = Apollo.QueryResult<CreditConsentStatusQuery, CreditConsentStatusQueryVariables>;
export const CustomerFileUploadUrlDocument = gql`
    query CustomerFileUploadUrl($fileName: String!) {
  customerFileUploadUrl(fileName: $fileName)
}
    `;

/**
 * __useCustomerFileUploadUrlQuery__
 *
 * To run a query within a React component, call `useCustomerFileUploadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerFileUploadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerFileUploadUrlQuery({
 *   variables: {
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useCustomerFileUploadUrlQuery(baseOptions: Apollo.QueryHookOptions<CustomerFileUploadUrlQuery, CustomerFileUploadUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerFileUploadUrlQuery, CustomerFileUploadUrlQueryVariables>(CustomerFileUploadUrlDocument, options);
      }
export function useCustomerFileUploadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerFileUploadUrlQuery, CustomerFileUploadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerFileUploadUrlQuery, CustomerFileUploadUrlQueryVariables>(CustomerFileUploadUrlDocument, options);
        }
export type CustomerFileUploadUrlQueryHookResult = ReturnType<typeof useCustomerFileUploadUrlQuery>;
export type CustomerFileUploadUrlLazyQueryHookResult = ReturnType<typeof useCustomerFileUploadUrlLazyQuery>;
export type CustomerFileUploadUrlQueryResult = Apollo.QueryResult<CustomerFileUploadUrlQuery, CustomerFileUploadUrlQueryVariables>;
export const CustomerFilesDocument = gql`
    query CustomerFiles {
  customerFiles {
    fileUploads {
      fileS3Key
      originalFileName
      createdAt
      documentType
      hubspotFileId
      isForCoApplicant
      s3Location
      status
    }
  }
}
    `;

/**
 * __useCustomerFilesQuery__
 *
 * To run a query within a React component, call `useCustomerFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerFilesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerFilesQuery(baseOptions?: Apollo.QueryHookOptions<CustomerFilesQuery, CustomerFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerFilesQuery, CustomerFilesQueryVariables>(CustomerFilesDocument, options);
      }
export function useCustomerFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerFilesQuery, CustomerFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerFilesQuery, CustomerFilesQueryVariables>(CustomerFilesDocument, options);
        }
export type CustomerFilesQueryHookResult = ReturnType<typeof useCustomerFilesQuery>;
export type CustomerFilesLazyQueryHookResult = ReturnType<typeof useCustomerFilesLazyQuery>;
export type CustomerFilesQueryResult = Apollo.QueryResult<CustomerFilesQuery, CustomerFilesQueryVariables>;
export const CustomerLegalDocumentsDocument = gql`
    query CustomerLegalDocuments {
  customerLegalDocuments {
    fileS3Key
    createdAt
    documentType
    s3Location
  }
}
    `;

/**
 * __useCustomerLegalDocumentsQuery__
 *
 * To run a query within a React component, call `useCustomerLegalDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerLegalDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerLegalDocumentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerLegalDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<CustomerLegalDocumentsQuery, CustomerLegalDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerLegalDocumentsQuery, CustomerLegalDocumentsQueryVariables>(CustomerLegalDocumentsDocument, options);
      }
export function useCustomerLegalDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerLegalDocumentsQuery, CustomerLegalDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerLegalDocumentsQuery, CustomerLegalDocumentsQueryVariables>(CustomerLegalDocumentsDocument, options);
        }
export type CustomerLegalDocumentsQueryHookResult = ReturnType<typeof useCustomerLegalDocumentsQuery>;
export type CustomerLegalDocumentsLazyQueryHookResult = ReturnType<typeof useCustomerLegalDocumentsLazyQuery>;
export type CustomerLegalDocumentsQueryResult = Apollo.QueryResult<CustomerLegalDocumentsQuery, CustomerLegalDocumentsQueryVariables>;
export const DownloadCustomerFileDocument = gql`
    query downloadCustomerFile($fileS3Key: String!) {
  downloadCustomerFile(fileS3Key: $fileS3Key)
}
    `;

/**
 * __useDownloadCustomerFileQuery__
 *
 * To run a query within a React component, call `useDownloadCustomerFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadCustomerFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadCustomerFileQuery({
 *   variables: {
 *      fileS3Key: // value for 'fileS3Key'
 *   },
 * });
 */
export function useDownloadCustomerFileQuery(baseOptions: Apollo.QueryHookOptions<DownloadCustomerFileQuery, DownloadCustomerFileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadCustomerFileQuery, DownloadCustomerFileQueryVariables>(DownloadCustomerFileDocument, options);
      }
export function useDownloadCustomerFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadCustomerFileQuery, DownloadCustomerFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadCustomerFileQuery, DownloadCustomerFileQueryVariables>(DownloadCustomerFileDocument, options);
        }
export type DownloadCustomerFileQueryHookResult = ReturnType<typeof useDownloadCustomerFileQuery>;
export type DownloadCustomerFileLazyQueryHookResult = ReturnType<typeof useDownloadCustomerFileLazyQuery>;
export type DownloadCustomerFileQueryResult = Apollo.QueryResult<DownloadCustomerFileQuery, DownloadCustomerFileQueryVariables>;
export const PreApprovalDetailsDocument = gql`
    query PreApprovalDetails {
  preApprovalResults {
    isApproved
    maxHomePrice
    monthlyRTOPayment
    monthlyRent
    monthlySavings
  }
}
    `;

/**
 * __usePreApprovalDetailsQuery__
 *
 * To run a query within a React component, call `usePreApprovalDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreApprovalDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreApprovalDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePreApprovalDetailsQuery(baseOptions?: Apollo.QueryHookOptions<PreApprovalDetailsQuery, PreApprovalDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreApprovalDetailsQuery, PreApprovalDetailsQueryVariables>(PreApprovalDetailsDocument, options);
      }
export function usePreApprovalDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreApprovalDetailsQuery, PreApprovalDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreApprovalDetailsQuery, PreApprovalDetailsQueryVariables>(PreApprovalDetailsDocument, options);
        }
export type PreApprovalDetailsQueryHookResult = ReturnType<typeof usePreApprovalDetailsQuery>;
export type PreApprovalDetailsLazyQueryHookResult = ReturnType<typeof usePreApprovalDetailsLazyQuery>;
export type PreApprovalDetailsQueryResult = Apollo.QueryResult<PreApprovalDetailsQuery, PreApprovalDetailsQueryVariables>;
export const CustomerReferralUrlDocument = gql`
    query CustomerReferralUrl {
  customerReferralUrl {
    shortUrl
    originalUrl
  }
}
    `;

/**
 * __useCustomerReferralUrlQuery__
 *
 * To run a query within a React component, call `useCustomerReferralUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerReferralUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerReferralUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerReferralUrlQuery(baseOptions?: Apollo.QueryHookOptions<CustomerReferralUrlQuery, CustomerReferralUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerReferralUrlQuery, CustomerReferralUrlQueryVariables>(CustomerReferralUrlDocument, options);
      }
export function useCustomerReferralUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerReferralUrlQuery, CustomerReferralUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerReferralUrlQuery, CustomerReferralUrlQueryVariables>(CustomerReferralUrlDocument, options);
        }
export type CustomerReferralUrlQueryHookResult = ReturnType<typeof useCustomerReferralUrlQuery>;
export type CustomerReferralUrlLazyQueryHookResult = ReturnType<typeof useCustomerReferralUrlLazyQuery>;
export type CustomerReferralUrlQueryResult = Apollo.QueryResult<CustomerReferralUrlQuery, CustomerReferralUrlQueryVariables>;
export const RejectionReasonsDocument = gql`
    query RejectionReasons {
  preApprovalResults {
    rejectionReasons {
      activeBankruptcy
      creditScoreTooLow
      debtTooHigh
      homePriceTooLow
      incomeTooLow
      savingsTooLow
    }
  }
}
    `;

/**
 * __useRejectionReasonsQuery__
 *
 * To run a query within a React component, call `useRejectionReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRejectionReasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRejectionReasonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRejectionReasonsQuery(baseOptions?: Apollo.QueryHookOptions<RejectionReasonsQuery, RejectionReasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RejectionReasonsQuery, RejectionReasonsQueryVariables>(RejectionReasonsDocument, options);
      }
export function useRejectionReasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RejectionReasonsQuery, RejectionReasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RejectionReasonsQuery, RejectionReasonsQueryVariables>(RejectionReasonsDocument, options);
        }
export type RejectionReasonsQueryHookResult = ReturnType<typeof useRejectionReasonsQuery>;
export type RejectionReasonsLazyQueryHookResult = ReturnType<typeof useRejectionReasonsLazyQuery>;
export type RejectionReasonsQueryResult = Apollo.QueryResult<RejectionReasonsQuery, RejectionReasonsQueryVariables>;
export const namedOperations = {
  Query: {
    ApplicantInfo: 'ApplicantInfo',
    ApplicantsEmploymentDetails: 'ApplicantsEmploymentDetails',
    ApplicationDetails: 'ApplicationDetails',
    ApplicationStatus: 'ApplicationStatus',
    CreditConsentStatus: 'CreditConsentStatus',
    CustomerFileUploadUrl: 'CustomerFileUploadUrl',
    CustomerFiles: 'CustomerFiles',
    CustomerLegalDocuments: 'CustomerLegalDocuments',
    downloadCustomerFile: 'downloadCustomerFile',
    PreApprovalDetails: 'PreApprovalDetails',
    CustomerReferralUrl: 'CustomerReferralUrl',
    RejectionReasons: 'RejectionReasons'
  },
  Mutation: {
    AddCoApplicant: 'AddCoApplicant',
    DeleteCustomerFile: 'DeleteCustomerFile',
    RemoveCoApplicant: 'RemoveCoApplicant',
    SendCoApplicantIncomeVerificationEmail: 'SendCoApplicantIncomeVerificationEmail',
    SendCoApplicantCreditReportEmail: 'SendCoApplicantCreditReportEmail',
    sendCustomerToCustomerInvitation: 'sendCustomerToCustomerInvitation',
    SubmitCreditReportConsent: 'SubmitCreditReportConsent',
    SubmitEmergencyContact: 'SubmitEmergencyContact',
    submitEmploymentDetails: 'submitEmploymentDetails',
    SubmitInspectionDate: 'SubmitInspectionDate',
    SubmitOffer: 'SubmitOffer',
    SubmitPreApproval: 'SubmitPreApproval',
    updateApplicationStatus: 'updateApplicationStatus',
    updateBankStatementStatus: 'updateBankStatementStatus',
    UpdateCustomerInfo: 'UpdateCustomerInfo',
    UploadCustomerFile: 'UploadCustomerFile'
  }
}